import { BookOpenTextIcon, BotIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, CogIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShieldCheckIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// =====================================================================
// KRLE KLAR™ – all landing content. GENERADO por fabrica/gen_landing.py desde la ficha (krle-klar). No editar a mano: editar la ficha.
// =====================================================================

import { MOCKUP_URL, PAGE_URLS, pageTexts } from './teknikMedia';
export { MOCKUP_URL, PAGE_URLS };

export const PRODUCT_IMAGE = MOCKUP_URL;
export const PRODUCT_IMAGE_ALT = 'KRLE KLAR-pakken: seks bind i KRLE for 1.–10. trinn med årsplan, økter, elevark, prøver og vurdering';

export const PRICE = '299 NOK';
export const ORIGINAL_PRICE = '599 NOK';

export const META = {
  title: 'KRLE KLAR™ – Ferdige KRLE-økter for 1.–10. trinn',
  description: 'Ferdig 6-i-1-system for KRLE 1.–10. trinn: årsplan, økter minutt for minutt, kristendom, andre religioner og livssyn, etikk og filosofi, høytider og vurdering, pluss 5 bonuser.',
  ogTitle: 'KRLE KLAR™ – Gå inn i KRLE-timen med alt klart',
  ogDescription: 'Hele skoleåret i KRLE – ferdig planlagt. Økter, elevark i tre nivåer, prøver og fasit for 1.–10. trinn. Umiddelbar nedlasting.'
};

export const topBar = {
  long: 'Hele skoleåret i KRLE – ferdig planlagt · Umiddelbar nedlasting · 7 dagers fornøydhetsgaranti',
  short: 'Hele skoleåret i KRLE · 7 dagers garanti'
};

export const copy = {
  ctaDefault: 'Skaff KRLE KLAR™ nå',
  hero: {
    before: 'Få',
    highlight: 'hele skoleåret',
    middle: 'i KRLE ferdig planlagt – kom i gang på',
    accent: '5 minutter',
    sub: 'Gå inn i KRLE-timen med alt klart. Seks digitale bind for 1.–10. trinn: årsplan, økter minutt for minutt, elevark i tre nivåer, prøver og vurdering.',
    badgeLine1: '6 bind',
    badgeLine2: '+ 5 bonuser'
  },
  stats: {
    title: 'Den komplette pakken i tall'
  },
  difference: {
    kicker: 'Forskjellen med KRLE KLAR™',
    titleStart: 'Fra improvisasjon i KRLE til',
    titleAccent: 'ro og struktur.',
    intro: 'Tenk deg å starte uken med KRLE-timene allerede planlagt. Du vet hva du skal si, hvilke spørsmål du kan stille og hvilke ark elevene skal ha.',
    beforeLabel: 'Før KRLE KLAR™',
    beforeTitle: 'Kjenner du deg igjen?',
    afterLabel: 'Med KRLE KLAR™',
    afterTitle: 'Planlegg mindre. Undervis mer.',
    closing: 'Bruk tiden på elevene som lytter, spør og tenker – ikke på å lete etter opplegg.'
  },
  recognize: {
    title: 'Har du noen gang opplevd dette?',
    text: 'Hvis du svarer ja på minst ett spørsmål, er KRLE KLAR™ for deg.',
    link: 'Du fortjener en enklere vei'
  },
  inside: {
    title: 'Hva inneholder',
    brand: 'KRLE KLAR™',
    packTitle: 'Hva gjør KRLE KLAR™ annerledes?',
    packText: 'Et helt skoleårs materiale i KRLE – religioner og livssyn, kristendom og kirkeår, etikk og filosofi, høytider og vurdering – samlet i ett system.'
  },
  pages: {
    kicker: 'Kikk inn i KRLE KLAR™',
    titleStart: 'Se hvordan materialet ser ut',
    titleAccent: 'på innsiden.',
    text: 'Ekte sider fra Bind 1: årsplan, lærersider minutt for minutt med mål og trygg ramme, elevark i tre nivåer og vurderingskriterier.'
  },
  bonuses: {
    kicker: 'Men det er mer!',
    titleStart: '5 bonuser',
    titleAccent: 'uten ekstra kostnad',
    text: 'Fem ekstra ressurser følger med de seks bindene – så du er klar for alt som skjer i klasserommet.'
  },
  how: {
    titleStart: 'Slik fungerer',
    brand: 'KRLE KLAR™',
    text: 'Fra nedlasting til klasserommet: forbered neste KRLE-time på bare noen minutter.',
    closing: 'Åpne → velg → forbered → undervis. Enkelt og oversiktlig.'
  },
  audience: {
    titleStart: 'Hvem er',
    brand: 'KRLE KLAR™',
    lead: 'Pakken er for deg som:',
    closing: 'Laget for lærere som underviser i KRLE og vil bruke mindre tid på å lete og mer tid på elevene.',
    asideTitle: 'Hva er tiden din verdt?',
    asideLead: 'Tenk på hvor mange timer du bruker på KRLE-planlegging hver uke:',
    asideText: 'Tenk deg nå en ferdig pakke som hjelper deg med alt dette – og som gir deg kvelden tilbake.',
    asideClosing: 'Du trenger ikke begynne fra null.'
  },
  offer: {
    titleStart: 'Oppdag din komplette',
    brand: 'KRLE KLAR™',
    titleEnd: '-pakke',
    text: 'Hele skoleåret i KRLE – ferdig planlagt. Kom i gang på 5 minutter.',
    includesLabel: 'Den komplette pakken inneholder',
    priceLabel: 'Introduksjonspris',
    originalLabel: 'Ord. pris',
    oneTime: 'Engangsbetaling. Ingen abonnement.',
    cta: 'Skaff hele pakken nå'
  },
  guarantee: {
    title: '7 dagers fornøydhetsgaranti',
    text: 'Last ned materialet og se hvordan det fungerer i din KRLE-undervisning.',
    legal: 'Garantien påvirker ikke rettighetene dine etter gjeldende forbrukerlovgivning.'
  },
  finalCta: {
    titleStart: 'KRLE-undervisningen din kan være',
    titleAccent: 'klar allerede i dag.',
    text: 'I stedet for å lete etter fortellinger, bilder og arbeidsark kan du åpne en økt, skrive ut elevarket og gå inn i klasserommet med en tydelig plan.',
    closing: 'Elevene dine. Undervisningen din. Fritiden din.',
    recap: ['6 bind', '240 sider', '72 økter', 'Elevark i 3 nivåer', 'Prøver + fasit', '5 bonuser'],
    oneTime: 'Engangsbetaling – ingen abonnement.',
    reassurances: ['Umiddelbar digital nedlasting', 'PDF-filer å lagre', '7 dagers fornøydhetsgaranti']
  },
  footer: {
    brand: 'KRLE KLAR',
    disclaimer: 'KRLE KLAR™ er uavhengig undervisningsmateriell i KRLE for 1.–10. trinn, bygget på kompetansemålene i LK20. Det er ikke utgitt av eller tilknyttet noen skole, kirke eller trossamfunn.',
    copyright: '© 2026 KRLE KLAR™ · edulabs. Alle rettigheter forbeholdt.'
  }
};

export const heroGuarantees = ['Umiddelbar digital nedlasting', 'Engangsbetaling', 'Ingen abonnement', '7 dagers fornøydhetsgaranti'];

export const stats = [{
  value: '240',
  label: 'Sider i seks bind'
}, {
  value: '72',
  label: 'Økter med lærerside og elevark'
}, {
  value: '12',
  label: 'Prøver A/B med fasit'
}, {
  value: '100',
  label: 'Ferdige tilbakemeldinger'
}, {
  value: '5',
  label: 'Bonuser som er med'
}];

export const differenceStats = [{
  value: '1.–10. trinn',
  label: 'Årsplan for 1.–4., 5.–7. og 8.–10. trinn'
}, {
  value: '6 digitale bind',
  label: 'Økter, kristendom, andre religioner, etikk, høytider og vurdering'
}, {
  value: 'Utskrivbare PDF-filer',
  label: 'Å skrive ut til klasserommet eller vise digitalt'
}];

export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Søndagskvelden går til planlegging',
  text: 'Du leter etter fortellinger, bilder og arbeidsark – og uken har ikke engang startet.'
}, {
  title: 'KRLE uten fordypning',
  text: 'Du underviser i faget, men har ikke utdanning i religionsvitenskap og vil gjøre det riktig.'
}, {
  title: 'Balansen må sitte',
  text: 'Du vil forklare alle religioner og livssyn rettferdig, uten å si hva som er sant.'
}, {
  title: 'Vanskelige spørsmål i klassen',
  text: 'Elever spør om døden, Gud og hva du selv tror – og du vil svare trygt.'
}, {
  title: 'Foreldrekontakt tar tid',
  text: 'Du trenger maler for brev, besøk og samtaler, og vil unngå misforståelser.'
}, {
  title: 'Vurderingen tar kveldene',
  text: 'Kjennetegn, prøver og tilbakemeldinger blir ekstra arbeid etter skoletid.'
}];

export const afterItems = ['En organisert pakke i KRLE for hele grunnskolen', 'Årsplan for 1.–4., 5.–7. og 8.–10. trinn', '72 ferdige økter med lærerside og elevark i tre nivåer', 'Balansert innhold om kristendom, jødedom, islam, hinduisme, buddhisme, sikhisme og humanetikk', 'Etikk og filosofi med ferdige samtaler og dilemmaer', 'Høytider, besøk og skole–hjem-maler', 'Prøver A/B med fasit og vurderingskriterier', '100 ferdige tilbakemeldinger'];

export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Kveldene går til planlegging',
  text: 'Sitter du kvelder og helger og planlegger neste ukes KRLE-timer?'
}, {
  icon: FolderSearchIcon,
  title: 'Du leter etter balanserte opplegg',
  text: 'Leter du etter materiell som forklarer alle religioner og livssyn rettferdig?'
}, {
  icon: ShieldCheckIcon,
  title: 'Trygge samtaler må sitte',
  text: 'Vil du ha tydelige samtaleregler og en trygg ramme som elevene faktisk følger?'
}, {
  icon: PencilRulerIcon,
  title: 'Du vil slippe å lage alt fra null',
  text: 'Ønsker du at økter, elevark, maler og prøver allerede var forberedt?'
}, {
  icon: ShuffleIcon,
  title: 'Elevene har ulike behov',
  text: 'Trenger du oppgaver i tre nivåer – for elever som trenger støtte og de som vil ha mer utfordring?'
}, {
  icon: LayoutGridIcon,
  title: 'Hele faget i samme system',
  text: 'Vil du ha kristendom, andre religioner, etikk, høytider og vurdering samlet, slik at du raskt finner det du trenger?'
}];

export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Bind 01',
  level: 'Årsplan',
  title: 'Årsplan + 12 økter minutt for minutt',
  tagline: 'Gå inn i KRLE-timen med alt klart.',
  intro: 'Det første bindet gir deg strukturen for hele skoleåret og tolv ferdige økter på 60 minutter – med lærerside og elevark i tre nivåer.',
  items: ['Årsplan for 1.–4., 5.–7. og 8.–10. trinn', 'Skoleåret uke for uke', 'Progresjonstabell', 'Kompetansemål etter trinn', 'Trygg samtale i KRLE', '12 økter minutt for minutt (60 min)', 'Elevark i 3 nivåer', 'Prøver med fasit og vurderingskriterier'],
  outro: 'Fra «Vi er ulike og alle hører til» på 1. trinn til «Mangfold og menneskerettigheter» på 10. trinn.',
  spine: 'bg-[#1F2A5C] text-white',
  rule: 'border-white/30'
}, {
  number: 'Bind 02',
  level: 'Kristendom',
  title: 'Kristendom – kirkeåret, Bibelen og høytidene',
  tagline: 'Fortell hva kristne tror og gjør.',
  intro: 'Det andre bindet gir deg 16 ferdige økter om Bibelen, kirkeåret og kristen tradisjon fra 1. til 10. trinn.',
  items: ['Skapelsen, Abraham og Moses', 'Advent, jul, fastetid, påske og pinse', 'Jesu liv og lignelsene', 'Kirken og gudstjenesten', 'Reformasjonen og Den norske kirke', 'Kirkesamfunn', 'Kristen etikk i dag', 'Prøve og ordliste'],
  outro: 'Alle økter forteller «kristne tror» – ingen elev blir bedt om å tro eller be.',
  spine: 'bg-[#7C4DAA] text-white',
  rule: 'border-white/30'
}, {
  number: 'Bind 03',
  level: 'Andre religioner',
  title: 'Andre religioner og livssyn',
  tagline: 'Verden i klasserommet.',
  intro: 'Det tredje bindet gir deg 16 økter om jødedom, islam, hinduisme, buddhisme, sikhisme, samisk tro og humanetikk.',
  items: ['Jødiske høytider og synagogen', 'Muhammed og Koranen', 'Ramadan, id og moskeen', 'Hinduismens guder og diwali', 'Buddhismens åttedelte vei', 'Sikhisme og samisk religion', 'Ateisme og livssyn uten gud', 'Dialog mellom livssyn'],
  outro: 'Balanserte formuleringer som «noen muslimer» og «mange hinduer».',
  spine: 'bg-[#E0A030] text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Bind 04',
  level: 'Etikk',
  title: 'Etikk og filosofi med barn',
  tagline: 'Tenk sammen – og tenk selv.',
  intro: 'Det fjerde bindet gir deg 16 økter med samtaler og dilemmaer, fra vennskap til menneskerettigheter.',
  items: ['Rett og galt', 'Vennskap og respekt', 'Å ta andres perspektiv', 'Rettferdighet og tillit', 'Mobbing og inkludering', 'Filosofisk samtale', 'Digital etikk', 'Etiske modeller'],
  outro: 'Fra første trinn til tiende – med trygge rammer for samtalen.',
  spine: 'bg-[#2F9E6B] text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Bind 05',
  level: 'Høytider',
  title: 'Høytider og tradisjoner i klasserommet + skole–hjem',
  tagline: 'Gode møter mellom skole og hjem.',
  intro: 'Det femte bindet gir deg årshjulet, 12 økter om høytider og maler for dialog med foresatte.',
  items: ['Årshjul for høytider', 'Jul, id, diwali, påske og samisk nasjonaldag', 'Overgangsritualer', 'Pilegrimsreiser og hellige steder', 'Foreldrebrev', 'Fritak og tilrettelegging (ikke juridisk rådgivning)', 'Besøk i trossamfunn', '«Hva gjør jeg?» – 8 situasjoner'],
  outro: 'Alt for et trygt samarbeid mellom skole og hjem.',
  spine: 'bg-[#2A7FBA] text-white',
  rule: 'border-white/30'
}, {
  number: 'Bind 06',
  level: 'Vurdering',
  title: 'Vurdering – kjennetegn, prøver og ferdige tilbakemeldinger',
  tagline: 'Vurder det eleven kan – ikke det eleven tror.',
  intro: 'Det sjette bindet gir deg kjennetegn, 12 prøver A/B med fasit og 100 ferdige tilbakemeldinger.',
  items: ['Prinsipper for vurdering i KRLE', 'Kjennetegn 1.–4., 5.–7. og 8.–10. trinn', 'Underveisvurdering', '12 prøver A/B med fasit', 'Muntlig og skriftlig vurdering', 'Egenvurdering', '100 ferdige tilbakemeldinger', 'Standpunkt på 10. trinn'],
  outro: 'Vurderingen bygger på kompetansemålene, ikke på troen.',
  spine: 'bg-[#C8453C] text-white',
  rule: 'border-white/30'
}];

export const volumesIntro = {
  title: '6 digitale bind for 1.–10. trinn',
  text: 'En komplett pakke i KRLE som hjelper deg med å planlegge og gjennomføre undervisningen hele skoleåret. Hvert bind inneholder 40 sider med økter, arbeidsark og fasit.'
};

export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Økter minutt for minutt',
  text: 'Slipp å begynne med et tomt dokument. 72 økter på 60 minutter med mål, materiell, trygg ramme og elevark i tre nivåer.'
}, {
  icon: CogIcon,
  title: 'Kristendom og kirkeår',
  text: 'Fra skapelsen til kirkeåret: advent, jul, fastetid, påske og pinse, samt reformasjonen og kirkesamfunn.'
}, {
  icon: LightbulbIcon,
  title: 'Andre religioner og livssyn',
  text: 'Jødedom, islam, hinduisme, buddhisme, sikhisme, samisk tro og humanetikk med balanserte formuleringer.'
}, {
  icon: BotIcon,
  title: 'Etikk og filosofi',
  text: 'Samtaler, dilemmaer og filosofi for alle trinn, fra vennskap til menneskerettigheter.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Vurdering',
  text: 'Kjennetegn, prøver A/B med fasit og 100 ferdige tilbakemeldinger.'
}, {
  icon: CalendarCheckIcon,
  title: 'Årsplan',
  text: 'Årsplan for 1.–4., 5.–7. og 8.–10. trinn, skoleåret uke for uke og progresjonstabell.'
}];

export const pageTypes = ['Økter minutt for minutt', 'Elevark i 3 nivåer', 'Trygg ramme i hver økt', 'Vurderingskriterier'];

export const bonuses: Array<{ title: string; text: string; items: string[]; benefit: string }> = [{
  title: 'KRLE-start på 5 minutter',
  text: '40 korte oppstarter som får i gang timen med en gang – med fasit.',
  items: ['10 «Hva er dette?»', '10 «Sant eller usant?»', '10 «Høytider og dager»', '10 «Hva ville du gjort?»'],
  benefit: 'Start hver KRLE-time med fokus – uten ekstra forberedelse.'
}, {
  title: 'Vikarpermen for KRLE',
  text: '10 økter som en vikar kan gjennomføre uten forberedelse.',
  items: ['Vi er ulike', 'En fortelling om en høytid', 'Lys i mørketiden', 'Rett og galt', 'Instruks og fasit'],
  benefit: 'Ro og orden også når du ikke kan være der.'
}, {
  title: 'Foreldrekommunikasjon i KRLE',
  text: 'Åtte ferdige brev og maler for kontakten med foresatte.',
  items: ['Årsstart', 'Før en høytid', 'Invitasjon til besøk', 'Dialog om tilrettelegging', 'Ukebrev'],
  benefit: 'Tydelig kommunikasjon på noen minutter.'
}, {
  title: 'Besøksguiden for KRLE',
  text: 'Seks ferdige besøk i kirke, moské, synagoge, tempel, gurdwara og seremonirom.',
  items: ['Før besøket', 'Under besøket', 'Gode spørsmål', 'Refleksjon etterpå'],
  benefit: 'Et trygt og respektfullt besøk – uten stress.'
}, {
  title: 'Plakater for KRLE-rommet',
  text: '20 plakater som gjør klasserommet tydelig og trygt.',
  items: ['Samtaleregler', 'Kirkeåret', 'Islams fem søyler', 'Den åttedelte vei', 'Menneskerettighetene'],
  benefit: 'Skriv ut og heng opp – med en gang.'
}];

export const steps = [{
  title: 'Åpne KRLE KLAR™',
  text: 'Last ned pakken og åpne bindet du trenger – årsplan, kristendom, andre religioner, etikk, høytider eller vurdering.'
}, {
  title: 'Velg økt',
  text: 'Finn riktig trinn og velg økt eller elevark i riktig nivå.'
}, {
  title: 'Forbered deg på 5 minutter',
  text: 'Gå gjennom lærersiden, materiell og trygg ramme.'
}, {
  title: 'Skriv ut og undervis',
  text: 'Skriv ut elevarkene eller vis dem digitalt – og gå inn i klasserommet med en tydelig plan.'
}];

export const audienceItems = ['Underviser i KRLE på 1.–10. trinn', 'Er kontaktlærer og har KRLE uten fordypning i faget', 'Vil ha et helt skoleårs KRLE organisert på ett sted', 'Vil ha balansert innhold som er trygt i klasserommet', 'Vil ha ferdige samtaler om etikk og filosofi', 'Trenger maler for foreldrekontakt og besøk', 'Trenger arbeidsark i tre nivåer', 'Vil ha ferdige vurderingskriterier og tilbakemeldinger'];

export const timeValueTasks = ['Lete etter balanserte fortellinger og bilder', 'Skrive samtaleregler og trygge rammer', 'Lage elevark i flere nivåer', 'Skrive foreldrebrev og besøksplaner', 'Lage prøver og tilbakemeldinger'];

export const offerRows = [{
  label: '6 digitale bind – 240 sider',
  detail: 'Årsplan og økter, kristendom og kirkeår, andre religioner og livssyn, etikk og filosofi, høytider og skole–hjem, vurdering'
}, {
  label: '5 bonuser uten ekstra kostnad',
  detail: 'KRLE-start, vikarpermen, foreldrekommunikasjon, besøksguiden og plakater'
}, {
  label: 'For 1.–10. trinn',
  detail: '72 økter, elevark i tre nivåer, prøver A/B med fasit og 100 ferdige tilbakemeldinger'
}];

export const offerIncludes = ['Umiddelbar digital nedlasting', 'PDF-filer å lagre', 'Utskrivbare elevark', 'Ingen fysisk produkt sendes'];

export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];

export const faqs = [{
  q: 'Hvordan får jeg materialet?',
  a: 'KRLE KLAR™ leveres digitalt. Etter kjøpet får du tilgang til PDF-filer som du kan laste ned og lagre. Du kan bruke materialet på PC, nettbrett og mobil, og skrive ut sidene du trenger.'
}, {
  q: 'Hvilke trinn passer det for?',
  a: '1.–10. trinn. Du får årsplaner for 1.–4., 5.–7. og 8.–10. trinn og økter for alle trinn.'
}, {
  q: 'Bygger materialet på LK20?',
  a: 'Ja. KRLE KLAR™ bygger på kjerneelementene og kompetansemålene i LK20 for KRLE. Det er uavhengig lærermateriell.'
}, {
  q: 'Er innholdet balansert?',
  a: 'Ja. Materialet forteller om kristendom, jødedom, islam, hinduisme, buddhisme, sikhisme, samisk tro og humanetikk med nøytrale formuleringer som «kristne tror» og «muslimer gjør». Ingen elev blir bedt om å tro eller be.'
}, {
  q: 'Hva ligger i de seks bindene?',
  a: 'Bind 1: årsplan og 12 økter. Bind 2: kristendom og kirkeåret. Bind 3: andre religioner og livssyn. Bind 4: etikk og filosofi med barn. Bind 5: høytider, tradisjoner og skole–hjem. Bind 6: vurdering.'
}, {
  q: 'Jeg har ikke fordypning i KRLE. Fungerer det likevel?',
  a: 'Ja. Hver økt har en lærerside med mål, materiell, trygg ramme og minutt for minutt, så du vet hva du skal gjøre og si.'
}, {
  q: 'Hva er bonusene?',
  a: 'KRLE-start på 5 minutter, Vikarpermen for KRLE, Foreldrekommunikasjon i KRLE, Besøksguiden for KRLE og Plakater for KRLE-rommet.'
}, {
  q: 'Hjelper materialet i samtaler med foresatte?',
  a: 'Ja. Bind 5 og bonusen om foreldrekommunikasjon gir maler og samtalestøtte. Det er ikke juridisk rådgivning, og du bør alltid avklare spørsmål om fritak med skolens ledelse.'
}, {
  q: 'Kan jeg skrive ut?',
  a: 'Ja. Alle ark er laget for utskrift på A4.'
}, {
  q: 'Hvor mye koster det?',
  a: 'Engangsbetaling på 299 NOK (ordinær pris 599 NOK). Ingen abonnement.'
}, {
  q: 'Kan jeg få pengene tilbake?',
  a: 'Ja, du har 7 dagers fornøydhetsgaranti. Garantien påvirker ikke rettighetene dine etter gjeldende forbrukerlovgivning.'
}, {
  q: 'Kan flere kolleger bruke materialet?',
  a: 'Materialet er til personlig bruk for deg som kjøper. Del gjerne ideer, men ikke selve filene.'
}, {
  q: 'Hva er forskjellen mellom bindene?',
  a: 'Bind 1 er rammen for året. Bind 2–5 er fordypning i tema. Bind 6 gir deg vurdering.'
}, {
  q: 'Hva om jeg trenger hjelp?',
  a: 'Kontakt oss via kontaktsiden. Vi svarer så fort vi kan.'
}];

export const footerLinks = ['Kjøpsvilkår', 'Personvernerklæring', 'Refusjonspolicy', 'Kontakt'];

export const pageSamples: Array<{ src: string; label: string; title: string; text: string }> = pageTexts.map((page, index) => ({
  ...page,
  src: PAGE_URLS[index] || ''
}));
